import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Appointment } from 'models/AppointmentModel';
import AsyncSelect from 'react-select/async';
import { useSearchParams } from 'react-router-dom';
import { Exam } from 'models/ExamModel';

const AppointmentForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.APPOINTMENT, Code.Form.Name.APPOINTMENT];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [postCheckOptions, setPostCheckOptions] = Hooks.Form.Options();
  const [branchOptions, setBranchOptions] = Hooks.Form.Options();
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Appointment>({});
  //const [examData, setExamData] = useState<Exam[]>([]);

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.OPTION+Code.Group.APPOINTMENT_TYPE, Code.Option.Common.SELECT, setTypeOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.APPOINTMENT_STATUS, Code.Option.Common.NA, setStatusOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.APPOINTMENT_INFO, Code.Option.Common.NA, setPostCheckOptions, setError);
    Files.Json.API(Code.File.LOCATION, Code.Option.Common.SELECT, setBranchOptions, setError);
    Files.Json.API(Code.File.DOCTOR, Code.Option.Common.SELECT, setDoctorOptions, setError);
    
    API.Data.GetByKeyId<Appointment>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.appointment_active); 
        const clientData = await API.Data.getClientNameNumber(data.client_id);
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
          ...clientData, 
        }));
        setLoading(false);
      }})

      const onNewEntry = async () => {
        if(keyId===Code.Key.NEW && clientId) {
          const clientName = await API.Data.GetClientName(Number(clientId));
          setFormData((prevData) => ({
            ...prevData,
            client_id: Number(clientId),
            client_name: Utility.Value.Text(clientName), 
          }));
        }
        setLoading(false);
      };
      onNewEntry();
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    // if(keyId==Code.Key.NEW){
    //   await callExamList(formData.client_id);
    // }
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
    });

    finalData.appointment_start_date = finalData.appointment_start_date || Utility.Date.Current();
    finalData.appointment_start_time = Utility.Convert.TimeOrNow(finalData.appointment_start_time);
    finalData.appointment_end_time = Utility.Convert.TimeOrNow(finalData.appointment_end_time);
    //finalData.newold_id = examData.length>0 ? 2 : 3

    console.log("finalData:",finalData);

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  // const callExamList = async (clientId: number | undefined) => {
  //     if (!clientId) return;  
  //     const url = API.Build.FormApiEndpint(Code.Form.Name.EXAM, 0, Name.Exam.Id, Code.Option.Sort.DESC, {
  //       fields: Utility.Join.Fields([
  //         Name.Exam.Id,
  //       ]),
  //       [Name.Client.Id]: clientId,
  //     });
  //     await API.Data.List<Exam>(url, setExamData, setError, setLoading);
  //   };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} clientNumber={formData.client_number} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Select id={Name.Common.TypeId} value={formData.type_id} title={Title.Type} options={typeOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} />
                <Field.Date id={Name.Appointment.StartDate} value={formData.appointment_start_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]}  require={true} currentDate={true}  />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.Doctor.Id} value={formData.doctor_id} title={Title.Doctor} options={doctorOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true}  />
                <Field.Select id={Name.Common.BranchId} value={formData.branch_id} title={Title.Location} options={branchOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Time id={Name.Appointment.StartTime} value={formData.appointment_start_time} title={Title.StartTime} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true}/>
                <Field.Time id={Name.Appointment.EndTime} value={formData.appointment_end_time} title={Title.EndTime} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true}  />
              </Control.Row>
              <Control.Box>
                <Field.Header id={Name.Client.Id} title={Title.Client} require={true}>
                  <AsyncSelect id={Name.Client.Id} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.CLIENT, Code.Mapping.client.value, Code.Mapping.client.label)} styles={Code.Style.FormOption} onChange={(selected) => Utility.Handle.ClientChange(selected, setFormData)} value={Utility.Value.Async(formData.client_id,formData.client_name)} placeholder="Search" />
                </Field.Header>
              </Control.Box>
              <Control.Box>
                <Field.Area id={Name.Appointment.Comment} value={formData.appointment_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Box>
              <Control.Row>
                <Field.Select id={Name.Common.StatusId} value={formData.status_id} title={Title.State} options={statusOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true}  />
                <Field.Select id={Name.Common.PostCheckId} value={formData.postcheck_id} title="Post Check Status" options={postCheckOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]}  />
              </Control.Row>
            </Control.Tab.Content>
 
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default AppointmentForm;